<app-crudbar [label]="title" (onReady)="doComReady($event,'crudbar')" [editAndSaveVisible]="false">
</app-crudbar>
<div>
  <div class="w-full top-10 border-2  bg-gray-100">
    @if(masterVisible){
    <div class="top-1 border-1">
      <app-utypi02 (onFormReady)="doFormReady($event,PageKind.master)">
      </app-utypi02>
    </div>
    }
    @if(detailVisible){
    <div class="top-1 border-1 border-green-400">
      <app-utypi02-detail (onFormReady)="doFormReady($event,PageKind.detail)">
      </app-utypi02-detail>
    </div>
    }
  </div>
  <div>